module.exports = __webpack_public_path__ + "img/background.1555b8b3.png";